export default __webpack_public_path__ + "static/media/excel.6984ed77.svg";